export const themeColors = {
    lenovo: "#3B83D1",
    bg: "#0C0D21",
    fg: "rgba(129, 134, 148, 0.13)",
    font: "#F1F5FF",
    fontSupplemental: "#818694",
}